import { useState, useEffect, useCallback } from 'react'
import { API, API_ROUTER } from '../../../api'

const useGames = () => {
  const [games, setGames] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  const getAllGames = useCallback(() => {
    setIsLoading(true)
    setError(null)

    API.request({
      ...API_ROUTER.games.getGames,
    })
      .then(res => {
        const formattedGames =
          res?.games?.map(el => ({
            id: el.id,
            value: el.title,
          })) || []
        setGames(formattedGames)
        setIsLoading(false)
      })
      .catch(err => {
        console.error('Error fetching games:', err)
        setError(err)
        setIsLoading(false)
      })
  }, [])

  useEffect(() => {
    getAllGames()
  }, [getAllGames])

  return {
    games,
    isLoading,
    error,
    refetch: getAllGames,
  }
}

export default useGames
